import { Component } from '@angular/core';

@Component({
  selector: 'app-admin-external-search-landing-page',
  standalone: false,
  templateUrl: './admin-external-search-landing-page.component.html',
  styleUrl: './admin-external-search-landing-page.component.scss'
})
export class AdminExternalSearchLandingPageComponent {
  public searchResults:any;
  public onPageChange:any;
  public isAirmenAgentSearch: boolean;
  public sortOrder:string;
  public onOperatorEdit : boolean;
  public resetPagination:boolean;
  public columns = [{ field: 'userName', displayName: 'User Name', isSortable: true },
    { field: 'email', displayName: 'Email', isSortable: false},
    { field: 'emailActivated', displayName: 'Is Email Activated', isSortable: false,},
  ];

  handleSearch(event:any){
    this.searchResults = event;
  }

  handlePageChange(event:any){
  this.onPageChange= event;
  }

  sortOrderForSearch(event:any){
    this.sortOrder=event;
  }

  IsSearchTypeAirmen(event:boolean)
  {
    this.isAirmenAgentSearch = event;
  }

  refreshOnOperatorEdit(event:any){
    this.onOperatorEdit=event;
  }
  handleResetPagination(event:boolean){
    this.resetPagination =event;
  }
}
